import React from 'react';
export function Footer() {
  return <footer className="w-full bg-paper px-5 py-10" data-id="element-104" data-mp="32wmqrybuniwl">
      <div className="mx-auto max-w-2xl text-center" data-id="element-105" data-mp="3gfsoch60l2p3">
        <p className="font-serif-display text-base font-semibold text-ink" data-id="element-106" data-mp="3ghc3u5juj9pt">CHIMIE VISUELLE™</p>
        <p className="mt-2 text-xs leading-relaxed text-ink/50" data-id="element-107" data-mp="32pp601a99t4x">
          Bibliothèque de ressources pédagogiques numériques · Aucun envoi postal
          <br data-id="element-108" data-mp="3ueiltxwqx4dz" />
          Paiement unique de 19 € · Aucun abonnement · Accès à vie
          <br data-id="element-109" data-mp="38qyt7e9m7ve" />
          Licence individuelle pour une utilisation dans les classes de l’enseignant qui effectue
          l’achat. La redistribution, le partage intégral, la modification en vue d’une revente et la
          vente des ressources ne sont pas autorisés.
        </p>
        <p className="mt-4 text-xs text-ink/40" data-id="element-110" data-mp="3qf9raqtvt2hd">
          Les illustrations et les modèles peuvent être simplifiés à des fins pédagogiques. Les
          formules, les valeurs, les unités et les explications écrites constituent la référence
          scientifique.
        </p>
        <p className="mt-4 text-xs text-ink/40" data-id="element-111" data-mp="3l9sj15twaup0">
          © 2026 CHIMIE VISUELLE™ by THE RESOURCE LAB. Tous droits réservés.
        </p>
      </div>
    </footer>;
}